import * as yup from 'yup'

export const LoadTypesSchema = yup.object({
  isLiveCapable: yup.boolean(),
  isDropCapable: yup.boolean(),
  isPowerOnly: yup.boolean(),
})

export type TLoadTypesSchema = yup.InferType<typeof LoadTypesSchema>
